/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	centeredPanel: {
		alignItems: 'center',
		display: 'flex',
		minHeight: '100vh'
	}
});

export default styles;
